<style src="@/assets/styles/components/modules/hosted-pages/subscribe.styl" lang="stylus" scoped></style>
<template>
  <div :class="customClass">
    <slot name="consent"></slot>
    <slot name="notes"></slot>
    <div class="cb-subscribe" :class="{'cb-subscribe--left': $slots['consent'] && tos_holder.show_checkbox}" v-if="tos_enabled">
      <input type="checkbox" ref="x" class="cb-subscribe__check" v-if="tos_holder.show_checkbox" v-model="tos_agreed" @keyup.enter="next()" id="tos_agreed" aria-required="true">
      <label class="cb-subscribe__label" :class="{'cb-subscribe__label--mandatory': $slots['consent'] && is_tos_cbx_showed}" for="tos_agreed" v-if="transformedContent && transformedContent.parts">
        <span v-if="transformedContent.parts[0]" v-cb-html="sanitizeLineBreaks(transformedContent.parts[0])"></span>
        <a :href='url(transformedContent.labels[0])' target='_blank' v-if="transformedContent.labels[0]" v-cb-link = "'color'" class="cb-subscribe__link">{{label(transformedContent.labels[0])}}</a>
        <span v-if="transformedContent.parts[1]" v-cb-html="sanitizeLineBreaks(transformedContent.parts[1])"></span>
        <a :href='url(transformedContent.labels[1])' target='_blank' v-if="transformedContent.labels[1]" v-cb-link = "'color'" class="cb-subscribe__link">{{label(transformedContent.labels[1])}}</a>
        <span v-if="transformedContent.parts[2]" v-cb-html="sanitizeLineBreaks(transformedContent.parts[2])"></span>
      </label>
      <label class="cb-subscribe__label" :class="{'cb-subscribe__label--mandatory': $slots['consent'] && is_tos_cbx_showed}" v-else for="tos_agreed">
        {{tos_holder.txt}}
      </label>
    </div>
    <cb-button v-if="btn_hide" :custom-class="'primary'" :show-loader="showLoader" :class="{'cb-button__disabled':btn_disabled}" :aria-disabled="disableButton" :btnDisabled="disableButton" :disabled="disableButton" @next="submit()" :attr="'review_submit'">
      {{getButtonTxt}}
    </cb-button>
    <div v-if="btn_hide" class="cb-subscribe cb-subscribe__footer"><i class="icon-lock" aria-hidden="true"></i>
    {{st('checkout_message')}} <template v-if="!hideBranding">{{st('chargebee_checkout')}}</template>
    </div>
  </div>
</template>
<script type="text/javascript">
import ButtonComponent from "@/components/collections/form/ButtonComponent";
import { mapGetters } from "vuex";
export default {
  props: ["showLoader", "customClass", "txtKey", "total", "hideButtonOverride", "disableAction"],
  components: {
    "cb-button": ButtonComponent
  },
  data() {
    return {
      transformedContent: {},
      hideBranding: false
    };
  },
  mounted() {
    this.hideBranding =
      window && window.initInfo && window.initInfo.hide_branding;
    if (this.tos_holder) {
      var template = this.tos_holder.txt;

      // To find starting index position of 'tos' merge var
      var tos_matcher = {
        matcher:
          template.match("{{legal_options.terms_of_service_url}}") ||
          template.match("%{tos}"),
        id: "tos"
      };

      // To find starting index position of 'privacy' merge var
      var privacy_matcher = {
        matcher:
          template.match("{{legal_options.privacy_policy_url}}") ||
          template.match("%{privacy_policy}"),
        id: "privacy"
      };

      // Substitute tos & privacy values in the template
      this.transformedContent = transformTos(
        template,
        tos_matcher,
        privacy_matcher
      );
    }
  },
  computed: {
    ...mapGetters([
      "tos_holder",
      "currency_code",
      "amount_due",
      "current_amount_due",
      "tos_enabled",
      "pm_consent"
    ]),
    // isConsentMandatory: this.$slots && this.$slots['consent'] && this.is_tos_cbx_showed(),
    tos_agreed: {
      get() {
        return this.$store.getters.tos_agreed;
      },
      set(value) {
        this.$store.dispatch("set_tos_agreed", value);
      }
    },
    btn_disabled() {
      return this.is_tos_cbx_showed() && !this.tos_agreed;
    },
    btn_hide() {
      return !this.hideButtonOverride;
    },
    getButtonTxt() {
      if(!this.txtKey && !this.total) { //if both txt and total are not passed as props
        if(this.$store.getters.translate("review.btn.txt")) { //for hpv3 settings version upto 2
          return this.t("review.btn.txt", {amount: this.$options.filters.cbCurrency(this.amount_due, this.currency_code)});
        } 
        if(this.current_amount_due > 0) {
          return this.t("review.subscribe_btn.current_charge_present.txt", {amount: this.$options.filters.cbCurrency(this.current_amount_due, this.currency_code)});
        } else {
          return this.t("review.subscribe_btn.current_charge_zero.txt", {amount: this.$options.filters.cbCurrency(this.current_amount_due, this.currency_code)});
        }
      }
      return this.t(this.txtKey, {amount: this.$options.filters.cbCurrency(this.total, this.currency_code)});
    },
    disableButton() {
      return this.btn_disabled || this.disableAction || !this.pm_consent;
    }
  },
  methods: {
    sanitizeLineBreaks(content) {
      return {
        text: content,
        tags: ["div"],
        attrs: {}
      };
    },
    next() {
      this.$refs.x.click();
    },
    is_tos_cbx_showed() {
      return this.tos_enabled && this.tos_holder.show_checkbox;
    },

    submit() {
      if (this.tos_agreed || !this.is_tos_cbx_showed()) {
        this.$emit("submit");
      }
    },

    label(id) {
      switch (id) {
        case "tos":
          return this.tos_holder.tos_label;
        case "privacy":
          return this.tos_holder.privacy_label;
      }
    },

    url(id) {
      switch (id) {
        case "tos":
          return this.tos_holder.tos_url;
        case "privacy":
          return this.tos_holder.privacy_url;
      }
    }
  }
};

var transformTos = function(template, group1, group2) {
  var output = [];
  var parts = [];
  if (group1.matcher && group2.matcher) { // If there are two sections TOS and Privacy
    // Get index of first merge var (can be either of tos / privacy)
    let firstMatcher =
      group1.matcher.index < group2.matcher.index ? group1 : group2;
    output.push(firstMatcher.id);

    // Get index of second merge var 
    let secondMatcher =
      group1.matcher.index >= group2.matcher.index ? group1 : group2;
    output.push(secondMatcher.id);

    // String text ${mergeVar1} some text ${mergeVar2}
    // ----------- ---------------------- ------------
    // Part 1           Part 2              Part 3
    parts.push(template.substring(0, firstMatcher.matcher.index)); // Plain text section
    
    parts.push( // from first mergeVar to start of second mergeVar
      template.substring(
        firstMatcher.matcher.index + firstMatcher.matcher[0].length,
        secondMatcher.matcher.index
      )
    );

    parts.push( // from second mergeVar to end of string
      template.substring(
        secondMatcher.matcher.index + secondMatcher.matcher[0].length,
        template.length
      )
    );

  } else if (group1.matcher) { // If there is only one section (either TOS / privacy)
    output = [group1.id];
    parts.push(template.substring(0, group1.matcher.index));
    parts.push(
      template.substring(
        group1.matcher.index + group1.matcher[0].length,
        template.length
      )
    );
  } else if (group2.matcher) { // If there is only one section (either TOS / privacy)
    output = [group2.id];
    parts.push(template.substring(0, group2.matcher.index));
    parts.push(
      template.substring(
        group2.matcher.index + group2.matcher[0].length,
        template.length
      )
    );
  } else {
    return null;
  }

  return {
    labels: output,
    parts: parts
  };
};
</script>

<style lang="stylus" scoped>
.cb-subscribe{
	&__{
		&check {
			margin-top:0;
			width:16px;
			height: 16px;
		}
	}
}
</style>